import React, { Component, Fragment } from "react";
// import firebase from "../../firebase";
import {MyStore} from '../../../../services/Store'
import { Route, NavLink, Link, Redirect, withRouter} from 'react-router-dom';
import {
    Menu,
    Icon,
    Modal,
    Form,
    Input,
    Button,
    Message,
    Label,
    Container,
    Card,
    Image, 
    Grid
} from "semantic-ui-react";

class Groups  extends Component {
        constructor(props){
        super(props)
        // console.log(props)
        this.state = {
            // user: this.props.currentUser,
            user: MyStore.auth().currentUser,
            // notifications: this.props.notifications,
            activeConvoId: props.activeConvoId,
            groups: [],
            showModal: false,
            groupName: "",
            groupDetails: "",
            groupsRef:   MyStore.database().ref("groups"),
            // dmRef: MyStore.database().ref("directMessages"),
            usersRef:   MyStore.database().ref("users"),
            // groupsRef: MyStore.database().ref().child("groups"),
            // dmRef: MyStore.database().ref().child("directMessages"),
            firstLoad: true,
            errors: []
        };
    }
    nextPath(path) {
        this.props.history.push(path);
      }


    displayErrors = errors =>
        errors.map((e, index) => <p key={index}>{e.message}</p>);

    displayGroups = groups =>
        groups.length > 0 &&
        groups.map(group => (
            <Menu.Item
                key={group.id}
                onClick={() => this.props.changeGroup(group)}
                name={group.name}
                style={{ opacity: 0.95 }}
                active={group.id === this.state.activeConvoId}>
                # {group.name}
                {/* {this.getNotifications(group.id) > 0 && (
                    <Label color="red">{this.getNotifications(group.id)}</Label>
                )} */}

            </Menu.Item>
        ));

    
    
    // displayGroups = groups =>
    //     groups.length > 0 &&
    //     groups.map(group => (
    //         <Button
    //             key={group.id}
    //             onClick={() => this.props.changeGroup(group)}
    //             name={group.name}
    //             style={{ opacity: 0.95 }}
    //             active={group.id === this.state.activeConvoId}>
    //             # {group.name}
    //             {/* {this.getNotifications(group.id) > 0 && (
    //                 <Label color="red">{this.getNotifications(group.id)}</Label>
    //             )} */}
    //         </Button>
    //     ));
    
    // displayOrganization = groups =>
    //     groups.length > 0 &&
    //     groups.map(group => (
    //         <React.Fragment>
    //             <Container>

    //             </Container>
    //         <Button
    //             key={group.id}
    //             onClick={() => this.props.changeGroup(group)}
    //             name={group.name}
    //             style={{ opacity: 0.95 }}
    //             active={group.id === this.state.activeConvoId}>
    //             # {group.name}
    //             {/* {this.getNotifications(group.id) > 0 && (
    //                 <Label color="red">{this.getNotifications(group.id)}</Label>
    //             )} */}
    //         </Button>
    //         </React.Fragment>
          
    //     ));
    // p.groove {border-style: groove;}


    // toOrgan=(id)=>{
    //     this.props.history.push(`/organization/${id}`);
    // }

    // toOrgan=(id)=>{
    //     console.log(id)
    //     if(id)
    //     return  (<Redirect  to={`/organization/${id}`}/>)
    // }

    toOrgan=(e)=>{
        // e.preventDefault()
        
        // console.log(e)
        // console.log(e.target.value)
        this.nextPath(`/cadre/${e.target.value}/dashboard`)
       
        // console.log('------------id  groups.js')

        // return  (
        //     <Redirect  to={`/dashboard/${e.target.value}`}
        //          />
        // )

        
    }

    displayOrganization = groups =>
        groups.length > 0 &&
        groups.map(group => (

            <Card style={{ 
            // marginLeft:'75px', marginRight: '75px',  
            margin:'auto',
                width: '25vh', borderStyle:'groove', 
                minHeight: '35vh', minWidth: '25vh', border: "5px solid transparent",boxShadow: "none", 
            }}
              key={group.id}
            //   active={group.id === this.state.activeConvoId}
            >
              <Image src={group.oavatar} wrapped ui={false} />
              <Card.Content  style={{padding: "0px"}}>
                <Card.Header>{group.oname}</Card.Header>
            <Card.Meta>{group.dateCreated}</Card.Meta>
                <Card.Description>
                  {/* {group.details.address}    {group.details.city} {group.details.postal} */}
                  1234 Address Blvd 91208
                </Card.Description>
                <Button inverted color='blue'  fluid
                 key={group.id}
                value={group.id}
                onClick={this.toOrgan.bind(this)}
                //   onClick={() => this.props.changeGroup(group)}
                 name={group.oname}
                 style={{ opacity: 0.95, float:'center' }}>
                  {group.oname}
             </Button>  
             <Icon name='user' /> { group.members.length } Members
              </Card.Content>
      
 
         <br></br>

              {/* <Button inverted color='blue' style={{height: '70px'}}
                 key={group.id}
                //  onClick={() => this.props.changeGroup(group)}
                //  active={group.id === this.state.activeConvoId}
                // onClick={(this.toOrgan(group.id))}
                // onClick={this.toOrgan.bind(this)(group.id)}
                value={group.id}
                onClick={this.toOrgan.bind(this)}
                 name={group.oname}
                 style={{ opacity: 0.95 }}>
                  {group.oname}
             </Button>   */}


            {/* this is a link to cadre */}
           {/* <Link  to={`/cadre/${group.id}`}>
                  {group.oname}

             </Link> */}
             
 

            </Card>
 
          
        ));
 

    
    // getNotifications = groupId => {
    //     const { notifications } = this.state;
    //     let index = notifications.findIndex(n => n.id === groupId);

    //     if (index !== -1) {
    //         return notifications[index].count;
    //     }
    // };

    openModal = () => {
        this.setState({
            showModal: true
        });
    };

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    isValidForm = ({ groupName, groupDetails }) => groupName && groupDetails;

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();

        this.setState({ errors: [] });

        if (!this.isValidForm(this.state)) {
            let error = {
                message: "Fill out both fields"
            };
            this.setState({ errors: this.state.errors.concat(error) });
        } else {
            this.createGroup();
            return true;
        }
    };

    /**
     * Set initial active group to first group in state
     * upon first page load
     */
    setFirstGroup = () => {
        const { groups, firstLoad } = this.state;
        if (firstLoad && groups.length > 0) {
            this.props.changeGroup(groups[0]);
        }
        this.setState({ firstload: false });
    };

    addGroupToUser = (snap, groupId) => {
        const { user, usersRef } = this.state;
        let userGroups = snap.child("groups").val();

        if (!userGroups) {
            userGroups = {};
        }

        userGroups[groupId] = {
            groupId: groupId,
            isMember: true
        };

        usersRef.child(user.uid).update({
            groups: userGroups
        });
    };

    createGroup = () => {
        const {
            groupsRef,
            groupName,
            groupDetails,
            user,
            usersRef
        } = this.state;

        const groupId = groupsRef.push().key;

        const newGroup = {
            id: groupId,
            name: groupName,
            details: groupDetails,
            createdBy: {
                username: user.displayName,
                avatar: user.photoURL
            },
            members: {
                [user.uid]: {
                    username: user.displayName, 
                    avatar: user.photoURL
                }
            }
        };

        groupsRef
            .child(groupId)
            .update(newGroup)
            .then(() => {
                usersRef.child(user.uid).once("value", snap => {
                    this.addGroupToUser(snap, groupId);
                });

                this.setState({ groupName: "", groupDetails: "" });
                this.closeModal();
            })
            .catch(error => {
                console.error(error);
            });
    };

    /**
     * Add groups belonging to user into component state so that
     * users will only see groups in the sidebar that they are
     * a member of
     */
    addGroupListener = () => {
        let loadedGroups = [];
        const { user, usersRef, groupsRef } = this.state;
        // console.log(usersRef)
        // const { addNotificationListener } = this.props;

        // Listen for new groups in groups child under users ref
        if(user){
            usersRef.child(user.uid).child("groups")
            .on("child_added", snap => {
                let groupId = snap.val().groupId;
                /**
                 * Get info from groups ref by group id in users ref
                 * and add it to our loaded groups in state
                 */
                groupsRef.child(groupId).once("value", snap => {
                    loadedGroups.push(snap.val());
                    this.setState(
                        {
                            groups: loadedGroups
                        },
                        () => this.setFirstGroup()
                    );
                });
                // addNotificationListener(groupId, false);
            });
        }
        else{
            return
        }

    };

    removeGroupListener = () => {
        this.state.usersRef.off();
    };

    /**
     * COMPONENT LIFECYCLE METHODS
     */
    static getDerivedStateFromProps(nextProps) {
        return {
            activeConvoId: nextProps.activeConvoId
        };
    }

    componentDidMount() {
        this.addGroupListener();
    }

    // componentDidUpdate(){
    //     this.addGroupListener();
    // }

    componentWillUnmount() {
        this.removeGroupListener();
    }

    render() {
        const { groups, showModal, errors } = this.state;
        
        return (
 
           

                <Grid style={{minwidth: "200vh", minHeight:"50vh"}}>
                {this.displayOrganization(groups)}
           
                </Grid>
     

     
        );
    }
}

// export default Groups;
export default withRouter(Groups);